<svg viewBox="0 0 16 18" xmlns="http://www.w3.org/2000/svg">
<path fill="currentColor" d="M-3.82781e-07 8.95L8.758 17.707L9.464 17L1.913 9.449L15.707 9.449L15.707 8.45L1.913 8.45L9.656 0.707L8.95 -3.91217e-07L-3.82781e-07 8.95Z" />
</svg>
